const toLocale = v => {
  if (typeof v !== "number") return "";

  return v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

export const toDecimal = v => {
  if (typeof v !== "number") return "";

  return v.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export default toLocale;
